import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Public
export const listProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const listCategories = () => api.get("/categories").then((r) => r.data);
export const listBundles = (params = {}) => api.get("/bundles", { params }).then((r) => r.data);
export const getBundle = (slug) => api.get(`/bundles/${slug}`).then((r) => r.data);

// Checkout
export const createCheckout = (payload) => api.post("/checkout/session", payload).then((r) => r.data);
export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
export const getOrder = (sessionId) => api.get(`/orders/${sessionId}`).then((r) => r.data);

// Chat
export const chat = (payload) => api.post("/chat", payload).then((r) => r.data);

// Newsletter
export const subscribeNewsletter = (email) =>
  api.post("/newsletter", { email }).then((r) => r.data);

// Admin
export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

const adminHeaders = () => ({
  headers: { "X-Admin-Token": localStorage.getItem("småstund_admin_token") || "" },
});

export const adminStats = () => api.get("/admin/stats", adminHeaders()).then((r) => r.data);
export const adminOrders = () => api.get("/admin/orders", adminHeaders()).then((r) => r.data);
export const adminProducts = () => api.get("/admin/products", adminHeaders()).then((r) => r.data);
export const adminDownloadPdfUrl = (slug) => {
  const pwd = encodeURIComponent(localStorage.getItem("småstund_admin_token") || "");
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  return `${base}/api/admin/download-pdf/${encodeURIComponent(slug)}?admin=${pwd}`;
};
export const adminCreateProduct = (data) =>
  api.post("/admin/products", data, adminHeaders()).then((r) => r.data);
export const adminUpdateProduct = (id, data) =>
  api.patch(`/admin/products/${id}`, data, adminHeaders()).then((r) => r.data);
export const adminDeleteProduct = (id) =>
  api.delete(`/admin/products/${id}`, adminHeaders()).then((r) => r.data);
export const adminGenerateMarketing = (data) =>
  api
    .post("/admin/generate-marketing", data, {
      ...adminHeaders(),
      timeout: 120000, // 2 minutes — AI generation can take 30-90s
    })
    .then((r) => r.data);

export const adminGenerateMarketingBulk = (data) =>
  api.post("/admin/generate-marketing-bulk", data, {
    ...adminHeaders(),
    timeout: 600000, // 10 minutes for 48 products
    responseType: "blob",
  });

// Discount codes (public)
export const validateDiscount = (code) =>
  api.post("/discount/validate", { code }).then((r) => r.data);

// Discount codes (admin)
export const adminListDiscountCodes = () =>
  api.get("/admin/discount-codes", adminHeaders()).then((r) => r.data);
export const adminCreateDiscountCode = (data) =>
  api.post("/admin/discount-codes", data, adminHeaders()).then((r) => r.data);
export const adminDeleteDiscountCode = (id) =>
  api.delete(`/admin/discount-codes/${id}`, adminHeaders()).then((r) => r.data);

// Reviews — public
export const getReviewToken = (token) =>
  api.get(`/reviews/token/${token}`).then((r) => r.data);
export const submitReview = (token, data) =>
  api.post(`/reviews/submit/${token}`, data).then((r) => r.data);
export const getProductReviews = (slug) =>
  api.get(`/products/${slug}/reviews`).then((r) => r.data);
export const getReviewsSummary = () =>
  api.get("/reviews/summary").then((r) => r.data);
export const getRelatedProducts = (slug, limit = 3) =>
  api.get(`/products/${slug}/related`, { params: { limit } }).then((r) => r.data);

// Campaigns (Launch banner)
export const getActiveCampaign = () =>
  api.get("/campaign/active").then((r) => r.data);
export const adminListCampaigns = () =>
  api.get("/admin/campaigns", adminHeaders()).then((r) => r.data);
export const adminCreateCampaign = (data) =>
  api.post("/admin/campaigns", data, adminHeaders()).then((r) => r.data);
export const adminToggleCampaign = (id, active) =>
  api.patch(`/admin/campaigns/${id}`, { active }, adminHeaders()).then((r) => r.data);
export const adminDeleteCampaign = (id) =>
  api.delete(`/admin/campaigns/${id}`, adminHeaders()).then((r) => r.data);

// Reviews — admin
export const adminListReviews = (status) =>
  api
    .get("/admin/reviews", { ...adminHeaders(), params: status ? { status } : {} })
    .then((r) => r.data);
export const adminUpdateReview = (id, status) =>
  api.patch(`/admin/reviews/${id}`, { status }, adminHeaders()).then((r) => r.data);
export const adminDeleteReview = (id) =>
  api.delete(`/admin/reviews/${id}`, adminHeaders()).then((r) => r.data);
